import { render } from "./ForgotPasswordConfirm.vue?vue&type=template&id=3a80c54e"
import script from "./ForgotPasswordConfirm.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordConfirm.vue?vue&type=script&lang=ts"
script.render = render

export default script